import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';
import cssVars from '@/styles/css-vars';
import utilities from '@/styles/utilities';

const CssBase = createGlobalStyle`
  :root {
    /* https://reach.tech/styling/#skip-including-styles */
    --reach-menu-button: 1;
    --reach-combobox: 1;
    --reach-listbox: 1;
    --reach-slider: 1;
    ${cssVars}
  }
  ${normalize}
  ${utilities}

  
  [data-reach-popover] {
    z-index: var(--z-indices-popover);
  }

  *,
  *::before,
  *::after {
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
    text-size-adjust: none;
  }

  *:focus {
    outline: none;
    /* box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.6); */
  }

  body {
    overflow-x: hidden;
    overflow-y: scroll;
    font-family: 'Noto Sans TC', 'Noto Sans JP', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Microsoft JhengHei, Arial, sans-serif;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--colors-dark-500);
  }

  h1, h2, h3, h4, h5, h6,
  input, textarea, button, select, label {
    color: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  img,
  svg,
  picture {
    display: block;
    max-width: 100%;
    height: auto;
  }

  a {
    text-decoration: none;
  }

  button {
    padding: 0;
    box-shadow: none;
    appearance: none;
    background: transparent;
    &[disabled] {
      cursor: not-allowed;
    }
  }

  a, button {
    cursor: pointer;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  input,
  select,
  textarea {
    padding: 0;
    box-shadow: none;
    appearance: none;
  }

  ${({ _css }) => _css && _css}
`;

export default CssBase;
